'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { Search } from '@morpho-org/ui-v6/client';
import AdvancedNetworkFilter from '@/components/common/TableAdvancedFilters/AdvancedNetworkFilter';
import VaultV2Filter from '@/components/common/VaultV2Filter/VaultV2Filter';
import { useIsMobile } from '@/hooks/useBreakpoints';
import type { CuratorAssetOptions } from '../config/curatorAssetOptions';
import type { CuratorVaultsFilters } from '../config/CuratorVaultsTable.config';
import AssetFilter from './AssetFilter';
interface CuratorVaultsTableFiltersProps {
  assetOptions: CuratorAssetOptions;
  filters: CuratorVaultsFilters;
  onFiltersChange: (filters: CuratorVaultsFilters) => void;
  withGlobalSearch: boolean;
  disabled: boolean;
  withNetworkFilter?: boolean;
}
const SEARCH_DEBOUNCE_TIME = 500;
const CuratorVaultsTableFilters = t0 => {
  const $ = _c(41);
  const {
    filters,
    onFiltersChange,
    disabled,
    withGlobalSearch,
    assetOptions,
    withNetworkFilter
  } = t0;
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== filters || $[1] !== onFiltersChange) {
    t1 = v2 => {
      onFiltersChange({
        ...filters,
        v2
      });
    };
    $[0] = filters;
    $[1] = onFiltersChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleV2Change = t1;
  let t2;
  if ($[3] !== filters || $[4] !== onFiltersChange) {
    t2 = assetIds => {
      onFiltersChange({
        ...filters,
        assets: assetIds
      });
    };
    $[3] = filters;
    $[4] = onFiltersChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleAssetIdsFilterChange = t2;
  let t3;
  if ($[6] !== filters.search || $[7] !== filters.v2 || $[8] !== onFiltersChange) {
    t3 = chainIds => {
      onFiltersChange({
        chains: chainIds,
        search: filters.search,
        v2: filters.v2,
        assets: []
      });
    };
    $[6] = filters.search;
    $[7] = filters.v2;
    $[8] = onFiltersChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleChainIdsFilterChange = t3;
  let t4;
  if ($[10] !== filters || $[11] !== onFiltersChange) {
    t4 = value => {
      onFiltersChange({
        ...filters,
        search: value.trim()
      });
    };
    $[10] = filters;
    $[11] = onFiltersChange;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleSearchChange = t4;
  const t5 = filters.v2 ?? false;
  let t6;
  if ($[13] !== disabled || $[14] !== handleV2Change || $[15] !== t5) {
    t6 = <VaultV2Filter isActive={t5} onChange={handleV2Change} isDisabled={disabled} page="curator_vaults" />;
    $[13] = disabled;
    $[14] = handleV2Change;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== disabled || $[18] !== filters.chains || $[19] !== handleChainIdsFilterChange || $[20] !== withNetworkFilter) {
    t7 = withNetworkFilter && <AdvancedNetworkFilter chainIdsFilter={filters.chains ?? []} handleChainIdsFilterChange={handleChainIdsFilterChange} disabled={disabled} page="curator_vaults" />;
    $[17] = disabled;
    $[18] = filters.chains;
    $[19] = handleChainIdsFilterChange;
    $[20] = withNetworkFilter;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== assetOptions || $[23] !== disabled || $[24] !== filters.assets || $[25] !== filters.chains || $[26] !== handleAssetIdsFilterChange) {
    t8 = <AssetFilter label="deposit" options={assetOptions} assets={filters.assets} chainIds={filters.chains} onAssetsChange={handleAssetIdsFilterChange} disabled={disabled} />;
    $[22] = assetOptions;
    $[23] = disabled;
    $[24] = filters.assets;
    $[25] = filters.chains;
    $[26] = handleAssetIdsFilterChange;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
    t9 = <div className="flex flex-wrap items-center gap-[12px_32px]">{t6}{t7}{t8}</div>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== disabled || $[33] !== filters.search || $[34] !== handleSearchChange || $[35] !== isMobile || $[36] !== withGlobalSearch) {
    t10 = <div className="gap-2xs my-auto flex w-auto self-end @max-[768px]:w-full"><Search placeholder="Filter vaults" width={200} fullWidth={isMobile} value={filters.search} onChange={handleSearchChange} disabled={disabled} debounceTime={SEARCH_DEBOUNCE_TIME} isGlobalSearchInput={withGlobalSearch} /></div>;
    $[32] = disabled;
    $[33] = filters.search;
    $[34] = handleSearchChange;
    $[35] = isMobile;
    $[36] = withGlobalSearch;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t9) {
    t11 = <div className="gap-sm @max-[768px]:gap-sm flex items-center justify-between @max-[768px]:flex-col @max-[768px]:items-start">{t9}{t10}</div>;
    $[38] = t10;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
};
export default CuratorVaultsTableFilters;